import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "@/i18n";
import Layout from "@/components/Layout";
import HomePage from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsPage from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import CookieBanner from "@/components/CookieBanner";
import { reapplyOnLoad } from "@/lib/consent";

function HashScrollHandler() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    // Wait a tick so the target section is in DOM (esp. right after route change).
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 30);
    return () => clearTimeout(t);
  }, [location.pathname, location.hash]);
  return null;
}

function App() {
  useEffect(() => {
    reapplyOnLoad();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <HashScrollHandler />
        <Routes>
          <Route path="/" element={<Navigate to="/ar" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />

          <Route path="/:lang" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="*" element={<HomePage />} />
          </Route>

          <Route path="*" element={<Navigate to="/ar" replace />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
